import { atom } from "recoil";

import { FavoriteItem } from "../AuthProvider";

export const favoritesAtom = atom<FavoriteItem[]>({
  key: "menu-favorites",
  default: [],
});
